/* ═══════════════════════════════════════════════════════════
   ShilajitNorge — theme.js
   Nav · Fade-in · Cart · Product Modal · epQty · Guided Commerce
═══════════════════════════════════════════════════════════ */

/* ── NAV SCROLL ── */
var nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', function () {
    nav.classList.toggle('scrolled', window.scrollY > 80);
  }, { passive: true });
}

/* ── FADE-IN ON SCROLL ── */
(function () {
  var fades = document.querySelectorAll('.fade-in');
  if (typeof IntersectionObserver !== 'undefined') {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    fades.forEach(function (el) { obs.observe(el); });
  } else {
    fades.forEach(function (el) { el.classList.add('visible'); });
  }
  document.querySelectorAll('#hero .fade-in').forEach(function (el) { el.classList.add('visible'); });
})();


/* ═══════════════════════════════════════════════════════════
   SHOPIFY CART (AJAX)
═══════════════════════════════════════════════════════════ */

/*
  GC_VARIANT_MAP — replace these placeholder IDs with your
  actual Shopify variant IDs after creating products.
  Format: 'format_tier': variantId
*/
var GC_VARIANT_MAP = {
  /* Resin 30g — brukes som standard resin i Guided Commerce */
  resin_starter:     47740099690661,
  resin_value:       47740099723429,
  resin_optimal:     47740099756197,
  /* Resin 75g */
  resin75_starter:   47740098511013,
  resin75_value:     47740098543781,
  resin75_optimal:   47740098576549,
  /* Kapsler 60 stk */
  kapsler_starter:   47740096872613,
  kapsler_value:     47740096905381,
  kapsler_optimal:   47740096938149,
  /* Kapsler 100 stk */
  kapsler100_starter: 47740096184485,
  kapsler100_value:   47740096217253,
  kapsler100_optimal: 47740096250021,
  /* Tabletter */
  tabletter_starter: 47740093595813,
  tabletter_value:   47740093628581,
  tabletter_optimal: 47740093661349
};

function addToCart(variantId, qty) {
  if (!variantId || variantId === 0) {
    console.warn('addToCart: ugyldig variant ID');
    return;
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function () { refreshCart(); openCart(); })
  .catch(function (err) { console.error('addToCart error:', err); });
}

function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) { renderCart(cart); });
}

function refreshCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); });
}

function renderCart(cart) {
  var itemsEl = document.getElementById('cart-items');
  var totalEl = document.getElementById('cart-total-price');
  var countEl = document.getElementById('cart-count');

  /* Oppdater GC progress bar og synk gratis-produkter */
  GC_STATE.cartTotal = cart.total_price / 100;
  gcUpdateRewards(GC_STATE.cartTotal);
  syncGiftTablet(cart);

  if (countEl) {
    countEl.textContent = cart.item_count;
    countEl.classList.toggle('visible', cart.item_count > 0);
  }

  if (totalEl) {
    totalEl.textContent = (cart.total_price / 100).toLocaleString('nb-NO') + ' kr';
  }

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">◈</div><span>Handlekurven er tom</span></div>';
    return;
  }

  var html = '';
  cart.items.forEach(function (item) {
    html += '<div class="cart-item">';
    html += '  <div class="cart-item-img">';
    if (item.image) html += '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy"/>';
    html += '  </div>';
    html += '  <div class="cart-item-info">';
    html += '    <div class="cart-item-name">' + item.product_title + '</div>';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '  <div class="cart-item-variant">' + item.variant_title + '</div>';
    }
    html += '    <div class="cart-item-price">' + (item.final_price < item.price ? '<s style="opacity:.55;font-size:.85em;margin-right:.35em">' + (item.price / 100).toLocaleString('nb-NO') + ' kr</s>' : '') + (item.final_price / 100).toLocaleString('nb-NO') + ' kr</div>';
    html += '    <div class="cart-item-qty">';
    html += '      <button class="cart-qty-btn" onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>';
    html += '      <span class="cart-qty-num">' + item.quantity + '</span>';
    html += '      <button class="cart-qty-btn" onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>';
    html += '    </div>';
    html += '  </div>';
    html += '  <button class="cart-item-remove" onclick="updateCartItem(\'' + item.key + '\',0)" title="Fjern">✕</button>';
    html += '</div>';
  });
  itemsEl.innerHTML = html;
}

function openCart() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}

function closeCart() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

/* Add to cart from product card (reads active variant from card data attrs) */
function addToCartFromCard(btn) {
  var card = btn.closest('.ep2-card');
  var activeQtyBtn = card.querySelector('.ep2-qty-btn.active');
  var btns = Array.from(card.querySelectorAll('.ep2-qty-btn'));
  var idx = btns.indexOf(activeQtyBtn);
  var variantId = parseInt(card.dataset['v' + (idx + 1)], 10);
  addToCart(variantId, 1);
}

/* Init cart count on load */
refreshCart();


/* ═══════════════════════════════════════════════════════════
   QUANTITY SELECTOR — enkeltprodukter cards (Shopify version)
   Reads variant IDs + prices from data-* on the card
═══════════════════════════════════════════════════════════ */
function epQtyShopify(btn, idx) {
  var card = btn.closest('.ep2-card');
  var btns = card.querySelectorAll('.ep2-qty-btn');
  btns.forEach(function (b) { b.classList.remove('active'); });
  btn.classList.add('active');

  var prices   = [card.dataset.p1, card.dataset.p2, card.dataset.p3];
  var saves    = [null, card.dataset.save2, card.dataset.save3];
  var isResin  = card.dataset.isResin === 'true';
  var priceEl  = card.querySelector('.ep2-price-main');
  var saveEl   = card.querySelector('.ep2-bundle-save');
  var wasEl    = card.querySelector('.ep2-was-resin');

  if (priceEl && prices[idx]) priceEl.textContent = prices[idx] + ' kr';

  if (saveEl) {
    if (saves[idx]) {
      saveEl.textContent = 'Spar ' + saves[idx] + ' kr';
      saveEl.style.display = 'inline-block';
    } else {
      saveEl.style.display = 'none';
    }
  }

  if (wasEl) wasEl.style.display = (idx === 0) ? '' : 'none';
}


/* ═══════════════════════════════════════════════════════════
   PRODUCT DETAIL MODAL
═══════════════════════════════════════════════════════════ */
var PD_DATA = {
  'altai-shilajit-resin-30g': {
    eyebrow: 'Altai Shilajit · Rå Resin',
    name:    'Altai Shilajit Resin',
    size:    '30 gram',
    badge:   null, sale: 'SPAR 30%',
    tags:    ['60 dagers bruk', '~9 kr / dag', 'Høyest biotilgjengelighet'],
    desc:    'Rå resin er den mest tradisjonelle og kraftfulle formen for shilajit. Direkte utvunnet fra Altai-fjellene uten prosessering som svekker næringsinnholdet. Ideelt for deg som vil ha maksimal effekt per dose.',
    specs:   [
      { label: 'Fulvinsyre',  val: '78–81%',               gold: true  },
      { label: 'Opprinnelse', val: 'Altai-fjellene, Sibir', gold: false },
      { label: 'Renhet',      val: 'Fri for tungmetaller',  gold: false },
      { label: 'Doseringer',  val: 'Ca. 60 × 0,5 g',       gold: false },
      { label: 'Lab-testet',  val: 'Hvert parti',           gold: true  }
    ],
    usage:   'Løs opp ca. 0,3–0,5 g (størrelse av en ert) i varmt vann, kaffe eller te. Inntas helst på tom mage om morgenen. Unngå kokende vann.'
  },
  'altai-shilajit-resin-75g': {
    eyebrow: 'Altai Shilajit · Rå Resin',
    name:    'Altai Shilajit Resin',
    size:    '75 gram — Best verdi',
    badge:   'BEST VERDI', sale: 'SPAR 30%',
    tags:    ['150 dagers bruk', '~6 kr / dag', 'Mest valgt av kunder'],
    desc:    'Den absolutt beste verdien i sortimentet. 75 gram holder i 150 dager — lavest kr-per-gram av alle formater. 78–81% fulvinsyre fra same Altai-kilde. Anbefales til alle faste brukere.',
    specs:   [
      { label: 'Fulvinsyre',  val: '78–81%',               gold: true  },
      { label: 'Opprinnelse', val: 'Altai-fjellene, Sibir', gold: false },
      { label: 'Renhet',      val: 'Fri for tungmetaller',  gold: false },
      { label: 'Doseringer',  val: 'Ca. 150 × 0,5 g',      gold: false },
      { label: 'Kr per gram', val: '11,96 kr/g',            gold: true  },
      { label: 'Lab-testet',  val: 'Hvert parti',           gold: true  }
    ],
    usage:   'Løs opp ca. 0,3–0,5 g i varmt vann, kaffe eller te. Inntas helst på tom mage om morgenen. Unngå kokende vann.'
  },
  'shilajit-tabletter': {
    eyebrow: 'Altai Shilajit · Tabletter',
    name:    'Shilajit Tabletter',
    size:    '120 stk · 400 mg per tablett',
    badge:   null, sale: null,
    tags:    ['60 dagers bruk', '~10 kr / dag', 'Presist dosert'],
    desc:    'Samme Altai Shilajit som resinen i en enkel, ferdigdosert tablett. 400 mg per tablett. Perfekt for en konsistent daglig rutine uten måling.',
    specs:   [
      { label: 'Innhold',     val: '120 tabletter',   gold: false },
      { label: 'Dosering',    val: '400 mg/tablett',  gold: true  },
      { label: 'Daglig dose', val: '1 tablett',       gold: false },
      { label: 'Varighet',    val: '60 dager',        gold: false },
      { label: 'Lab-testet',  val: 'Hvert parti',     gold: true  }
    ],
    usage:   'Ta 1 tablett daglig med et glass vann, helst om morgenen på tom mage. Bruk sammenhengende i minst 60 dager.'
  },
  'shilajit-kapsler-60': {
    eyebrow: 'Altai Shilajit · Kapsler',
    name:    'Shilajit Kapsler',
    size:    '60 stk · 500 mg per kapsel',
    badge:   null, sale: null,
    tags:    ['60 dagers bruk', '~12,5 kr / dag', '500 mg daglig'],
    desc:    '500 mg Altai Shilajit per kapsel — høyere dose per enhet enn tablettene. Enkel å svelge. Ideelt for deg som reiser mye eller foretrekker kapsler.',
    specs:   [
      { label: 'Innhold',     val: '60 kapsler',    gold: false },
      { label: 'Dosering',    val: '500 mg/kapsel', gold: true  },
      { label: 'Daglig dose', val: '1 kapsel',      gold: false },
      { label: 'Varighet',    val: '60 dager',      gold: false },
      { label: 'Lab-testet',  val: 'Hvert parti',   gold: true  }
    ],
    usage:   'Ta 1 kapsel daglig med et glass vann, helst om morgenen på tom mage.'
  },
  'shilajit-kapsler-100': {
    eyebrow: 'Altai Shilajit · Kapsler',
    name:    'Shilajit Kapsler',
    size:    '100 stk · 500 mg per kapsel',
    badge:   'BEST VERDI', sale: null,
    tags:    ['100 dagers bruk', '~9,5 kr / dag', 'Mest valgt'],
    desc:    'Den mest populære kapsel-pakken. 100 kapsler med 500 mg gir 100 dagers sammenhengende bruk — og lavest pris per dag i kapselformat.',
    specs:   [
      { label: 'Innhold',     val: '100 kapsler',   gold: false },
      { label: 'Dosering',    val: '500 mg/kapsel', gold: true  },
      { label: 'Daglig dose', val: '1 kapsel',      gold: false },
      { label: 'Varighet',    val: '100 dager',     gold: false },
      { label: 'Kr per dag',  val: '~9,5 kr',       gold: true  },
      { label: 'Lab-testet',  val: 'Hvert parti',   gold: true  }
    ],
    usage:   'Ta 1 kapsel daglig med et glass vann, helst om morgenen på tom mage. Anbefalt minimum 90 dager.'
  }
};

var PD_CURRENT_HANDLE = null;
var PD_CURRENT_CARD   = null;

function openPD(handle, imgEl) {
  var d = PD_DATA[handle];
  if (!d) return;
  PD_CURRENT_HANDLE = handle;

  var card = imgEl ? imgEl.closest('.ep2-card') : null;
  PD_CURRENT_CARD = card;

  var imgDest = document.getElementById('pd-img');
  if (imgEl && imgEl.src) { imgDest.src = imgEl.src; imgDest.alt = d.name; }

  var bdg  = document.getElementById('pd-badge');
  var sale = document.getElementById('pd-sale');
  if (d.badge) { bdg.textContent  = d.badge;  bdg.style.display  = 'block'; } else { bdg.style.display  = 'none'; }
  if (d.sale)  { sale.textContent = d.sale;   sale.style.display = 'block'; } else { sale.style.display = 'none'; }

  document.getElementById('pd-eyebrow').textContent   = d.eyebrow;
  document.getElementById('pd-name').textContent       = d.name;
  document.getElementById('pd-size').textContent       = d.size;
  document.getElementById('pd-desc').textContent       = d.desc;
  document.getElementById('pd-usage-text').textContent = d.usage;

  document.getElementById('pd-tags').innerHTML = d.tags.map(function (t) {
    return '<span class="pd-tag">' + t + '</span>';
  }).join('');

  document.getElementById('pd-specs').innerHTML = d.specs.map(function (s) {
    return '<div class="pd-spec">' +
      '<span class="pd-spec-label">' + s.label + '</span>' +
      '<span class="pd-spec-val' + (s.gold ? ' pd-spec-val-gold' : '') + '">' + s.val + '</span>' +
      '</div>';
  }).join('');

  var qtyBtns = document.querySelectorAll('.pd-qty-btn');
  qtyBtns.forEach(function (b, i) { b.classList.toggle('active', i === 0); });
  pdQty(qtyBtns[0], 0);

  document.getElementById('pd-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function pdQty(btn, idx) {
  document.querySelectorAll('.pd-qty-btn').forEach(function (b) { b.classList.remove('active'); });
  btn.classList.add('active');

  if (!PD_CURRENT_CARD) {
    document.getElementById('pd-price').textContent = '';
    document.getElementById('pd-was').textContent   = '';
    document.getElementById('pd-saving').style.display = 'none';
    return;
  }

  var card    = PD_CURRENT_CARD;
  var prices  = [card.dataset.p1, card.dataset.p2, card.dataset.p3];
  var saves   = [null, card.dataset.save2, card.dataset.save3];

  document.getElementById('pd-price').textContent = (prices[idx] || '') + ' kr';

  var wasEl = document.getElementById('pd-was');
  if (idx === 0 && PD_DATA[PD_CURRENT_HANDLE]) {
    var d = PD_DATA[PD_CURRENT_HANDLE];
    if (d.sale && card.querySelector('.ep2-was-resin')) {
      var wasSpan = card.querySelector('.ep2-was-resin');
      wasEl.textContent = wasSpan ? wasSpan.textContent : '';
    } else { wasEl.textContent = ''; }
  } else { wasEl.textContent = ''; }

  var savEl = document.getElementById('pd-saving');
  if (saves[idx]) { savEl.textContent = 'Spar ' + saves[idx] + ' kr'; savEl.style.display = 'inline-block'; }
  else { savEl.style.display = 'none'; }
}

function pdAddToCart() {
  if (!PD_CURRENT_CARD) return;
  var activeBtn = document.querySelector('.pd-qty-btn.active');
  var allBtns   = Array.from(document.querySelectorAll('.pd-qty-btn'));
  var idx       = allBtns.indexOf(activeBtn);
  var variantId = parseInt(PD_CURRENT_CARD.dataset['v' + (idx + 1)], 10);
  addToCart(variantId, 1);
  closePD();
}

function closePD() {
  document.getElementById('pd-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePD(); closeCart(); } });


/* ═══════════════════════════════════════════════════════════
   GUIDED COMMERCE
═══════════════════════════════════════════════════════════ */
var GC_STATE = { format: null, tier: null, cartTotal: 0 };

/* Gratis-produkter som auto-legges til/fjernes basert på kurv-total */
var GC_FREE_REWARDS = [
  { threshold: 1400, variantId: 47742306615461 }, /* Gratis Resin 30g   */
  { threshold: 1400, variantId: 47742325194917 }, /* Gratis Tabletter   */
  { threshold: 3200, variantId: 47742326341797 }, /* Gratis Kapsler 60  */
  { threshold: 4200, variantId: 47742322376869 }, /* Gratis Resin 75g   */
];
var GC_SYNCING = false;

function gcSyncFreeRewards(cart) {
  if (GC_SYNCING) return;
  var total = cart.total_price / 100;
  var cartIds = cart.items.map(function(i) { return i.variant_id; });

  var toAdd = [];
  var toRemove = [];

  GC_FREE_REWARDS.forEach(function(r) {
    var inCart = cartIds.indexOf(r.variantId) !== -1;
    if (total >= r.threshold && !inCart) {
      toAdd.push(r.variantId);
    } else if (total < r.threshold && inCart) {
      var item = cart.items.filter(function(i) { return i.variant_id === r.variantId; })[0];
      if (item) toRemove.push(item.key);
    }
  });

  if (toAdd.length === 0 && toRemove.length === 0) return;

  GC_SYNCING = true;
  var adds = toAdd.map(function(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    });
  });
  var removes = toRemove.map(function(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  });

  Promise.all(adds.concat(removes))
    .then(function() { GC_SYNCING = false; refreshCart(); })
    .catch(function(e) { GC_SYNCING = false; console.error('gcSync error:', e); });
}

var CDN = 'https://cdn.shopify.com/s/files/1/0762/7535/1717/files/';
var GC_PRODUCTS = {
  resin: {
    fullName: 'Altai Shilajit Resin',
    tiers: {
      starter: { label:'BASIS',    meta:'30g · 60 dagers bruk',       price:547,  saving:252, savingLabel:'30% rabatt', recommended:false, img: CDN+'30_gram_resin.png' },
      value:   { label:'STANDARD', meta:'75g · 150 dagers bruk',       price:897,  saving:402, savingLabel:'30% rabatt', recommended:true,  img: CDN+'Resin_75Grams_1x_15b33fee-88c1-4f85-84be-2bad0d8ede86.png' },
      optimal: { label:'MAKSIMAL',meta:'2×75g · 300 dagers bruk',     price:1547, saving:1051, savingLabel:'Spar 1051 kr (30% rabatt)', recommended:false, img: CDN+'Resin_75Grams_2x_5f2a9f7c-23ff-4223-9b5c-217aaaebc65c.png' }
    }
  },
  kapsler: {
    fullName: 'Shilajit Kapsler',
    tiers: {
      starter: { label:'BASIS',    meta:'60 stk · 60 dagers bruk',     price:697,  saving:null, recommended:false, img: CDN+'Shilajit_kapsler_60.png' },
      value:   { label:'STANDARD', meta:'100 stk · 100 dagers bruk',   price:949,  saving:null, recommended:true,  img: CDN+'Shilajit_kapsler_100.png' },
      optimal: { label:'MAKSIMAL',meta:'2×100 stk · 200 dagers bruk', price:1747, saving:149,  recommended:false, img: CDN+'Shilajit_kapsler_100_2x_f6d7e803-2fc2-49bb-ac0c-316b739685e0.png' }
    }
  },
  tabletter: {
    fullName: 'Shilajit Tabletter',
    tiers: {
      starter: { label:'BASIS',    meta:'120 stk · 60 dagers bruk',    price:599,  saving:null, recommended:false, img: CDN+'Shilajit_Tabletter_1x_3bcf37d4-ab61-4c0d-b51c-d2466107e80e.png' },
      value:   { label:'STANDARD', meta:'2×120 stk · 120 dagers bruk', price:999,  saving:199,  recommended:true,  img: CDN+'Shilajit_Tabletter_2x_be7a65c3-24ab-4507-b742-f1c052eec956.png' },
      optimal: { label:'MAKSIMAL',meta:'3×120 stk · 180 dagers bruk', price:1400, saving:398,  recommended:false, img: CDN+'Shilajit_Tabletter_3x_a55c2c69-976f-45dd-a099-8f524923111f.png' }
    }
  }
};

var GC_REWARDS = [
  { threshold:800,  label:'Gratis frakt',         sub:'Standard levering',   icon:'✓' },
  { threshold:1400, label:'Gratis Resin 30g',      sub:'Verdi 547 kr',        icon:'◈' },
  { threshold:2100, label:'Gratis Tabletter',       sub:'Verdi 600 kr',        icon:'▣' },
  { threshold:3200, label:'Gratis Kapsler 60 stk', sub:'Verdi 697 kr',        icon:'◉' },
  { threshold:4200, label:'Gratis Resin 75g',      sub:'Verdi 897 kr',        icon:'◈' }
];

var GC_BRIDGES = {
  resin:     { text:'Legg til <strong>Tabletter (599 kr)</strong> og lås opp Gratis Kapsler — kun ' },
  kapsler:   { text:'Legg til <strong>Resin 30g (547 kr)</strong> og kom nærmere Gratis Kapsler — kun ' },
  tabletter: { text:'Legg til <strong>Resin 30g (547 kr)</strong> for å bygge videre — kun ' }
};

function gcInitMilestones() {
  var el = document.getElementById('gc-milestones');
  if (!el) return;
  el.innerHTML = GC_REWARDS.map(function (r) {
    return '<div class="gc-ms" id="gc-ms-' + r.threshold + '">' +
      '<div class="gc-ms-dot">' + r.icon + '</div>' +
      '<div class="gc-ms-text">' +
        '<div class="gc-ms-label">' + r.label + '</div>' +
        '<div class="gc-ms-sub">'   + r.sub   + '</div>' +
      '</div>' +
      '<div class="gc-ms-kr">' + r.threshold.toLocaleString('nb-NO') + ' kr</div>' +
    '</div>';
  }).join('');
}

function gcSelectFormat(fmt) {
  GC_STATE.format = fmt;
  GC_STATE.tier   = null;

  document.querySelectorAll('.gc-fmt-card').forEach(function (c) {
    c.classList.toggle('active', c.dataset.fmt === fmt);
  });

  var prod    = GC_PRODUCTS[fmt];
  var tiersEl = document.getElementById('gc-tiers');
  tiersEl.innerHTML = ['starter','value','optimal'].map(function (tk) {
    var t = prod.tiers[tk];
    return '<div class="gc-tier-card' + (t.recommended ? ' active' : '') + '" data-tier="' + tk + '" onclick="gcSelectTier(this.dataset.tier)">' +
      (t.recommended ? '<div class="gc-tier-rec">ANBEFALT</div>' : '') +
      (t.img ? '<img src="' + t.img + '" class="gc-tier-img" alt="' + t.label + '" loading="lazy">' : '') +
      '<div class="gc-tier-label">'  + t.label + '</div>' +
      '<div class="gc-tier-meta">'   + t.meta  + '</div>' +
      '<div class="gc-tier-price">'  + t.price.toLocaleString('nb-NO') + ' kr</div>' +
      (t.saving ? '<div class="gc-tier-saving">' + (t.savingLabel || ('Spar ' + t.saving + ' kr')) + '</div>' : '') +
    '</div>';
  }).join('');

  var tierArea = document.getElementById('gc-tier-area');
  tierArea.style.opacity       = '1';
  tierArea.style.pointerEvents = 'auto';

  var rec = null;
  ['starter','value','optimal'].forEach(function (tk) { if (prod.tiers[tk].recommended) rec = tk; });
  if (rec) gcSelectTier(rec);

  // Auto-scroll to tier area on mobile
  if (window.innerWidth < 768) {
    setTimeout(function() {
      tierArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
}

function gcSelectTier(tk) {
  GC_STATE.tier = tk;
  var fmt  = GC_STATE.format;
  var prod = GC_PRODUCTS[fmt];
  var tier = prod.tiers[tk];

  document.querySelectorAll('.gc-tier-card').forEach(function (c) {
    c.classList.toggle('active', c.dataset.tier === tk);
  });

  var boxEl = document.getElementById('gc-selected-box');
  boxEl.innerHTML =
    '<span>' + prod.fullName + '<br><small style="color:rgba(245,240,232,.4);font-size:.72rem">' + tier.meta + '</small></span>' +
    '<span class="gc-selected-price">' + tier.price.toLocaleString('nb-NO') + ' kr</span>';
  document.getElementById('gc-cta-area').style.display = 'block';

  gcUpdateRewards(GC_STATE.cartTotal + tier.price);
}

function gcAddToCart() {
  if (!GC_STATE.format || !GC_STATE.tier) return;
  var key       = GC_STATE.format + '_' + GC_STATE.tier;
  var variantId = GC_VARIANT_MAP[key];
  if (!variantId) {
    alert('Oppdater GC_VARIANT_MAP i theme.js med dine Shopify variant-IDer.');
    return;
  }
  addToCart(variantId, 1);
}

function gcUpdateRewards(total) {
  var railFill  = document.getElementById('gc-rail-fill');
  var railThumb = document.getElementById('gc-rail-thumb');
  // GC elements only exist on homepage — skip safely on other pages
  if (!railFill || !railThumb) return;

  var pct = Math.min(total / 4200 * 100, 100);
  railFill.style.width  = pct + '%';
  railThumb.style.left  = pct + '%';

  var nextReward = null;
  GC_REWARDS.forEach(function (r) {
    var el = document.getElementById('gc-ms-' + r.threshold);
    if (!el) return;
    if (total >= r.threshold) { el.classList.add('unlocked'); }
    else { el.classList.remove('unlocked'); if (!nextReward) nextReward = r; }
  });

  var subEl = document.getElementById('gc-rw-sub');
  if (subEl) {
    if (nextReward) {
      subEl.textContent = 'Du er kun ' + (nextReward.threshold - total).toLocaleString('nb-NO') + ' kr unna: ' + nextReward.label;
      subEl.style.color = 'rgba(212,170,58,.8)';
    } else {
      subEl.textContent = 'Alle fordeler er låst opp! ✦';
      subEl.style.color = 'var(--gold2)';
    }
  }

  var bridgeEl = document.getElementById('gc-bridge');
  var bridgeIn = document.getElementById('gc-bridge-inner');
  if (bridgeEl && bridgeIn) {
    if (total >= 2100 && total < 3200 && GC_STATE.format) {
      var b = GC_BRIDGES[GC_STATE.format] || GC_BRIDGES.resin;
      bridgeIn.innerHTML = b.text + '<strong>' + (3200 - total).toLocaleString('nb-NO') + ' kr</strong> unna Gratis Kapsler.';
      bridgeEl.style.display = 'block';
    } else {
      bridgeEl.style.display = 'none';
    }
  }
}

(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gcInitMilestones);
  } else {
    gcInitMilestones();
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        GC_STATE.cartTotal = cart.total_price / 100;
        gcUpdateRewards(GC_STATE.cartTotal);
      });
  }
})();

/* Gratis tablett ved 1400 kr (loop-trygg, kun ett produkt) */
var GIFT_TAB_VARIANT = 47742325194917;
var GIFT_TAB_THRESHOLD = 1400;
var GIFT_TAB_SYNCING = false;
var GIFT_TAB_FAILED = false;
function syncGiftTablet(cart) {
  if (GIFT_TAB_SYNCING || GIFT_TAB_FAILED) return;
  var total = cart.total_price / 100;
  var gift = cart.items.filter(function (i) { return i.variant_id === GIFT_TAB_VARIANT; })[0];
  if (total >= GIFT_TAB_THRESHOLD && !gift) {
    GIFT_TAB_SYNCING = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: GIFT_TAB_VARIANT, quantity: 1 }) })
      .then(function (r) {
        GIFT_TAB_SYNCING = false;
        if (!r.ok) { GIFT_TAB_FAILED = true; console.warn('Gratis tablett kunne ikke legges til - sjekk at produktet er aktivt, 0 kr og paa lager.'); return; }
        refreshCart();
      })
      .catch(function () { GIFT_TAB_SYNCING = false; GIFT_TAB_FAILED = true; });
  } else if (total < GIFT_TAB_THRESHOLD && gift) {
    GIFT_TAB_SYNCING = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: gift.key, quantity: 0 }) })
      .then(function () { GIFT_TAB_SYNCING = false; refreshCart(); })
      .catch(function () { GIFT_TAB_SYNCING = false; });
  }
}
